"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetType = void 0;
/**
 * @internal
 */
var PresetType;
(function (PresetType) {
    PresetType["CUSTOM_FORMAT"] = "customFormat";
})(PresetType = exports.PresetType || (exports.PresetType = {}));
//# sourceMappingURL=typings.js.map